import { render, staticRenderFns } from "./FinishedProductHanding.vue?vue&type=template&id=10b2aa16&scoped=true"
import script from "./FinishedProductHanding.vue?vue&type=script&lang=js"
export * from "./FinishedProductHanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2aa16",
  null
  
)

export default component.exports